import React, { FC } from 'react'
import { FieldRenderProps } from 'react-final-form'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { Switch, FormControlLabel } from '@mui/material'

interface RFFCustomSwitchProps extends FieldRenderProps<unknown, HTMLElement> {
  // Optional: none of the four config sites that register this component pass it —
  // three pass nothing and one passes `customLabel`. The component already falls back
  // (`customLabel || fieldLabel`). Previously unenforceable because the registry slot
  // was untyped, so the required `string` was never actually checked.
  fieldLabel?: string
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom'
  customLabel?: React.ReactNode
  customClass?: string
}

const useStyles = makeStyles()((theme: Theme) => ({
  switch: {
    marginBottom: theme.spacing(3),
    '& > span': {
      color: theme.palette.info.dark,
      fontSize: '1rem',
    },
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    marginLeft: '3px',
  },
}))

const RFFCustomSwitch: FC<RFFCustomSwitchProps> = ({
  input,
  customLabel,
  fieldLabel,
  labelPlacement = 'end',
  customClass = '',
}) => {
  const { classes, cx } = useStyles()

  return (
    <FormControlLabel
      control={
        <Switch
          onChange={input.onChange}
          name={input.name}
          value={input.value}
          checked={input.checked}
          edge='start'
        />
      }
      id={input.name}
      label={customLabel || fieldLabel}
      className={cx(classes.switch, customClass)}
      labelPlacement={labelPlacement}
    />
  )
}

export default RFFCustomSwitch
